<template>
  <div class="board-wrap flex items-center justify-center relative">
    <!-- 棋盘 -->
    <div
      id="board"
      ref="board"
      class="cg-board-wrap cg-board flex items-center justify-center"
    ></div>
    <!-- 调试弹窗 -->
    <el-dialog title="加载fen" :visible.sync="fenVisible" width="30%">
      <el-input
        type="textarea"
        placeholder="请输入fen"
        v-model="fenStr"
      ></el-input>
      <span slot="footer" class="dialog-footer">
        <el-button @click="toggleFenVisible(false)">取 消</el-button>
        <el-button type="primary" @click="loadFen">确 定</el-button>
      </span>
    </el-dialog>
    <!-- pgn modal -->
    <el-dialog title="加载pgn" :visible.sync="pgnVisible" width="30%">
      <el-input
        type="textarea"
        placeholder="请输入pgn"
        v-model="pgnStr"
      ></el-input>
      <span slot="footer" class="dialog-footer">
        <el-button @click="togglePgnVisible(false)">取 消</el-button>
        <el-button type="primary" @click="loadPgn">确 定</el-button>
      </span>
    </el-dialog>
    <error-step-dialog :visible.sync="errorStepDialogConfig.visible" :step="errorStepDialogConfig.step" @confirm="handleErrorConfirm"/>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Chess from 'chess.js'
import CustomChessboard from '@/render/utils/custom-chessboard'
import { ErrorStepDialog } from '@/render/components/dialog'
import { uniques, initStockFish } from '@/render/utils/helpers'
import { SQUARE_CLASS, MOVE_DEST, BOARD_ID } from './const'
const { engine, uciCmd } = initStockFish()
export default {
  name: 'LobbyRoomPage',
  components: {
    ErrorStepDialog
  },
  props: {
    showNotation: {
      type: Boolean,
      default: true,
    },
    fen: {
      type: String,
      default: '',
    },
    free: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    showThreats: {
      type: Boolean,
      default: true,
    },
    onPromotion: {
      type: Function,
      default: () => 'q',
    },
    orientation: {
      type: String,
      default: 'white',
    },
    turn: {
      type: String,
      default: 'w',
    },
    roomId: {
      type: String,
    },
  },
  data() {
    return {
      board: null,
      $board: null,
      socket: null,
      fenVisible: false,
      pgnVisible: false,
      fenStr: '',
      pgnStr: '',
      squareToHighlight: null,
      colorToHighlight: null,
      engine,
      uciCmd,
      errorStepDialogConfig: {
        visible: false,
        step: ''
      },
    }
  },
  computed: {
    ...mapGetters('grading', ['currQuestion', 'testPaper', 'currQuestionTypeIdx', 'moveErrorCount', 'moveErrorStep', 'moveMode']),
  },
  created() {
    this.game = new Chess()
    this.board = null
  },
  watch: {
    disabled: {
      immediate: true,
      handler(disabled) {
        console.log('======', disabled)
        this.board && (this.board.disabled = disabled)
      }
    }
  },
  mounted() {
    window.vm = this
    this.initGame()
  },
  methods: {
    handleErrorConfirm() {
      this.errorStepDialogConfig.visible = false
    },
    initStockFish() {
      if (engine) {
        this.exceStockfish()
      }
    },
    exceStockfish() {
      const { game, board } = this
      engine.onmessage = function(event) {
        let line = event && typeof event === 'object' ? event.data : event
        let match = line.match(/^bestmove ([a-h][1-8])([a-h][1-8])([qrbn])?/)
        /// Did the AI move?
        if (match) {
          const from = match[1]
          const to = match[2]
          const promotion = match[3]
          game.move({ from, to, promotion })
          board.move(`${from}-${to}`)
          /// Is it sending feedback?
        }
      }
    },
    toggleFenVisible(flg = false) {
      this.fenVisible = flg
      if (flg) {
      } else {
        this.fenStr = ''
      }
    },
    togglePgnVisible(flg = false) {
      this.pgnVisible = flg
      if (flg) {
      } else {
        this.pgnStr = ''
      }
    },
    loadFen() {
      const { game, board } = this
      game.load(this.fenStr)
      board.position(this.fenStr)
      this.toggleFenVisible(false)
    },
    loadPgn() {
      const { game, board } = this
      game.load_pgn(this.pgnStr)
      board.position(game.fen())
      this.togglePgnVisible(false)
    },
    /**
     * 初始化棋局
     * @param {boolean} flg 是否初始化为 start
     */
    async initGame(flg = false) {
      const {
        showNotation,
        fen,
        orientation,
        onChange,
        onDragStart,
        onDragMove,
        onDrop,
        onMouseoutSquare,
        onMouseoverSquare,
        onMoveEnd,
        onSnapbackEnd,
        onSnapEnd,
      } = this
      const { player_turn } = this.configs

      if (!flg) {
        const config = {
          draggable: true,
          showNotation,
          sparePieces: false,
          position: fen || 'start',
          orientation,
          onChange,
          onDragStart,
          onDragMove,
          onDrop,
          onMouseoutSquare,
          onMouseoverSquare,
          onMoveEnd,
          onSnapbackEnd,
          onSnapEnd,
          pieceTheme: '/assets/themes/default/{piece}.png',
        }
        const expandConfig = {
          mode: this.moveMode,
          player_turn,
          game: this.game,
          disabled: this.disabled,
          highlightValidSquare: this.highlightValidSquare,
          removeHighlightValidSquare: this.removeHighlightValidSquare
        }
        this.board = CustomChessboard(this.$refs.board, config, expandConfig) // window.Chessboard(this.$refs.board, config)
        this.$board = $('#board')
        this.game.load(fen)
        this.board.position(fen)
      } else {
        this.game.reset()
        this.board.start()
      }
      this.initStockFish()
      // 执黑翻转棋盘
      if (player_turn === 'b') {
        this.board.flip()
      }
      this.afterMove({ no_ws: player_turn === this.game.turn() })

      $(window).resize(this.board.resize)
    },
    onChange(...args) {
      this.afterMove({ no_ws: true })
    },
    getMoves() {
      const { game } = this
      let moves = ''
      let history = game.history({ verbose: true })
      for (let i = 0; i < history.length; ++i) {
        let move = history[i]
        moves +=
          ' ' + move.from + move.to + (move.promotion ? move.promotion : '')
      }
      return moves
    },
    onDragStart(...args) {
      console.log('args', args)
      const { game, disabled, configs } = this
      const piece = args[1]
      console.log('piece', piece)
      const turn = game.turn()
      const { player_turn } = configs
      // disabled
      console.log('disabled', disabled)
      if (disabled) return false
      if (
        (turn === 'w' && piece.search(/^b/) !== -1) ||
        (turn === 'b' && piece.search(/^w/) !== -1) ||
        turn !== player_turn
      ) {
        return false
      }
      this.moveMode === 'drag' && this.highlightValidSquare()
      if (game.game_over()) {
        this.onGameOver()
        return false
      }
    },
    onDragMove(...args) {
      // console.log('onDragMove', args)
    },
    async onDrop(...args) {
      const { game, configs, removeHighlightValidSquare, board, free } = this
      const player_turn = configs.player_turn
      let [source, target, piece] = args
      console.log('args', args)
      // 落子国际象棋实战对决走错逻辑
      // Object.assign(this.errorStepDialogConfig, {
      //   visible: true,
      //   step: `${source} — ${target}`
      // })
      if (target !== 'offboard' && free && player_turn === game.turn() && source !== target) {
        let pieceCanMoves = this.calcPieceCanMoves(args)
        let moveErrorCount = Number(this.moveErrorCount)
        let moveErrorStep = this.moveErrorStep
        const errorStep = `${piece.slice(-1) + source} => ${piece.slice(-1) + target}`
        if (pieceCanMoves && !pieceCanMoves.includes(target) && !this.$route.query.testLogUid) { // 步数走错了
          moveErrorCount += 1
          moveErrorStep.push(errorStep)
          if (moveErrorCount === 1) {
            Object.assign(this.errorStepDialogConfig, {
              visible: true,
              step: errorStep
            })
          } else if (moveErrorCount === 2) {
            this.$emit('over', { is_win: false })
          }
          this.$store.commit('grading/setMoveErrorCount', moveErrorCount)
          this.$store.commit('grading/setMoveErrorStep', moveErrorStep)
        }
      }
      removeHighlightValidSquare()
      let promotion = 'q'
      if (this.isPromotion(piece, source, target)) {
        if (this.$parent.onPromotion) {
          // illegal move
          if (this.handleCanMove(source, target, promotion, game.fen())) {
            promotion = await this.$parent.onPromotion()
          } else {
            return 'snapback'
          }
        }
      }

      // see if the move is legal
      const move = game.move({
        from: source,
        to: target,
        promotion,
        sloppy: true,
      })
      // illegal move
      if (move === null) return 'snapback'
      if (move.promotion) {
        board.position(game.fen())
      }
      this.afterMove({ immediate: true })
    },
    handleCanMove(source, target, promotion, fen) {
      const game = new Chess()
      game.load(fen)
      const move = game.move({
        from: source,
        to: target,
        promotion,
        sloppy: true,
      })
      return !!move
    },
    onMouseoutSquare(...args) {
      this.$emit('onMouseoutSquare', ...args)
      this.moveMode === 'drag' && this.removeHighlightValidSquare()
    },
    onMouseoverSquare(...args) {
      // console.log('onMouseoverSquare', args)

      const { game, disabled, configs, free } = this
      const { player_turn } = configs
      const [square] = args

      const moves = game.moves({
        square: square,
        verbose: true,
      })

      // exit if there are no moves available for this square
      if (moves.length === 0) return

      // highlight the possible squares for this piece
      for (var i = 0; i < moves.length; i++) {
        const move = moves[i]
        if (!disabled && move.color === player_turn) {
          !free && (this.moveMode === 'drag' && this.highlightValidSquare(move.to))
        }
      }
      this.$emit('onMouseoverSquare', ...args)
    },
    calcPieceCanMoves(args) {
      const { game, configs } = this
      const { player_turn } = configs
      const [square] = args
      const moves = game.moves({
        square: square,
        verbose: true,
      })
      let movePosition = []
      // exit if there are no moves available for this square
      if (moves.length === 0) return
      for (var i = 0; i < moves.length; i++) {
        const move = moves[i]
        if (move.color === player_turn) {
          movePosition = [...movePosition, move.to]
        }
      }
      return movePosition
    },
    onMoveEnd(...args) {
      // this.board.position(this.game.fen(), false)
      console.log('onMoveEnd', args)
    },
    onSnapbackEnd(...args) {
      console.log('onSnapbackEnd', args)
    },
    onSnapEnd(...args) {
      console.log('onSnapEnd', args)
    },
    /***********************************************/
    /**
     * 高亮显示可移动有效区块
     */
    highlightValidSquare(square) {
      console.log('square', square)
      const $square = $(`#${BOARD_ID} .square-${square}`)
      $square.addClass(MOVE_DEST)
    },
    removeHighlightValidSquare() {
      const $squares = $(`#board ${SQUARE_CLASS}`)
      $squares.removeClass(MOVE_DEST)
    },
    /**********************************************/
    possibleMoves() {
      const dests = {}
      this.game.SQUARES.forEach(s => {
        const ms = this.game.moves({ square: s, verbose: true })
        if (ms.length) dests[s] = ms.map(m => m.to)
      })
      return dests
    },
    opponentMoves() {
      let originalPGN = this.game.pgn()
      let tokens = this.game.fen().split(' ')
      tokens[1] = tokens[1] === 'w' ? 'b' : 'w'
      tokens = tokens.join(' ')
      let valid = this.game.load(tokens)
      if (valid) {
        let moves = this.game.moves({ verbose: true })
        this.game.load_pgn(originalPGN)
        return moves
      } else {
        return []
      }
    },
    toColor() {
      return this.game.turn() === 'w' ? 'white' : 'black'
    },
    other_side_turn() {
      return this.game.turn() === 'w' ? 'b' : 'w'
    },
    isPromotion(piece, from, to) {
      return piece.includes('P') && (to.includes('1') || to.includes('8'))
    },
    calcCaptures() {
      const history = this.game.history({ verbose: true })
      const initial = {
        w: { p: 0, n: 0, b: 0, r: 0, q: 0, value: [] },
        b: { p: 0, n: 0, b: 0, r: 0, q: 0, value: [] },
      }

      const captures = history.reduce(function(acc, move) {
        if ('captured' in move) {
          const piece = move.captured
          // switch colors since the history stores the color of the player doing the
          // capturing, not the color of the captured piece
          const color = move.color === 'w' ? 'b' : 'w'
          acc[color][piece] += 1
          acc[color].value.push(move)
          return acc
        } else {
          return acc
        }
      }, initial)

      this.$emit('captured', captures)

      return captures
    },
    doCheckKing() {
      // 检查是否将军
      const { game } = this
      if (game.in_check()) {
        $(`.square-55d63 img[data-piece="${game.turn()}K"]`)
          .parent()
          .addClass('king-check')
      } else {
        $(`.square-55d63`).removeClass('king-check')
      }
    },
    afterMove({ no_ws, immediate }) {
      console.log('afterMove')
      this.$emit('move')
      let currQuestion = this.currQuestion
      const squareClass = 'square-55d63'
      const { game, board, $board, free } = this
      const history = game.history({ verbose: true })
      // 高亮显示最后一步
      const move = history[history.length - 1]
      if (move) {
        $board.find('.' + squareClass).removeClass('highlight-white')
        $board.find('.' + squareClass).removeClass('highlight-black')
        if (move.color === 'w') {
          $board.find('.square-' + move.from).addClass('highlight-white')
          this.squareToHighlight = move.to
          this.colorToHighlight = 'white'
        } else {
          $board.find('.square-' + move.from).addClass('highlight-black')
          this.squareToHighlight = move.to
          this.colorToHighlight = 'black'
        }
        $board
          .find('.square-' + this.squareToHighlight)
          .addClass('highlight-' + this.colorToHighlight)
      }

      // 吃子
      this.calcCaptures()
      if (currQuestion.typeCode && currQuestion.typeCode === 'ai') {
        // 检查将军
        this.doCheckKing()
      }
      // 游戏结束
      if (game.game_over()) {
        this.onGameOver()
        return false
      }
      if (!no_ws) {
        uciCmd('position fen ' + game.fen() || 'start')
        // 国际象棋战术题
        if (currQuestion.typeCode === 'national_iconic') {
          // 一步杀
          let description = JSON.parse(currQuestion.description)
          const { AIMove, personMove } = description[0]
          let is_win = false
          const moveSan = move.san.replace(/[#x+]/gi, '')
          let findIdx = personMove.findIndex(ele => {
            return ele.value === moveSan
          })
          if (description.length === 2 && game.history().length < 3) {
            // 两步杀
            if (game.history().length === 1) {
              // 第一步没有走对
              if (findIdx === -1) {
                uciCmd('go nodes 5')
              } else {
                game.move(AIMove[0].value)
                board.move(AIMove[0].value)
              }
            } else {
              findIdx = description[1].personMove.findIndex(ele => {
                return ele.value === moveSan
              })
            }
          }
          if (findIdx > -1) {
            is_win = true
          }
          this.$emit('over', { is_win })
        } else if (currQuestion.typeCode === 'ai') { // 国际象棋实战对决
          // 判断是否有深度
          if (currQuestion.engineState === 2) {
            uciCmd(currQuestion.aiDeep)
          } else {
            // 没有，随机走一步
            const moveArray = game.moves()
            const randomIdx = parseInt(Math.random() * moveArray.length)
            game.move(moveArray[randomIdx])
            board.move(moveArray[randomIdx])
            this.$store.commit('replay/setNextStepFlag', false)
          }
        }
      } else {
        // 更新棋局UI
        setTimeout(
          () => {
            board.position(game.fen())
          },
          immediate ? undefined : 100,
        )
      }
    },
    onGameOver() {
      const { game, configs } = this
      const color = this.toColor()
      const { player_turn_color } = configs
      let is_win = 0
      if (player_turn_color !== color && game.in_checkmate()) {
        is_win = 1
      }
      this.$emit('over', { is_win })
    },
    countThreats(color) {
      let threats = {}
      let captures = 0
      let checks = 0
      let moves = this.game.moves({ verbose: true })
      if (color !== this.toColor()) {
        moves = this.opponentMoves()
      }
      if (moves.length === 0) {
        return null // It´s an invalid position
      }
      moves.forEach(function(move) {
        if (move['captured']) {
          captures++
        }
        if (move['san'].includes('+')) {
          checks++
        }
      })
      threats[`legal_${color}`] = uniques(moves.map(x => x.from + x.to)).length // promotions count as 4 moves. This remove those duplicates moves.
      threats[`checks_${color}`] = checks
      threats[`threat_${color}`] = captures
      threats[`turn`] = color
      return threats
    },
  },
}
</script>

<style lang="scss" scoped>
.board-wrap {
  width: val(714);
  height: val(714);
  background: #e5c09f;
  box-shadow: 0px 3px 8px rgba(0, 0, 0, 0.5);
  padding: val(10);
  box-sizing: border-box;
  .board-operation {
    top: val(8);
    right: val(-58);
    width: val(56);
    border: 1px solid #ffffff37;
    border-left: none;
    span {
      display: block;
      padding: val(24) 0px;
      margin: 0px val(11);
      &:not(:last-child) {
        border-bottom: 1px solid #ffffff27;
      }
      img {
        width: val(24);
        height: val(24);
      }
      &.fullscreen {
        img {
          width: val(23);
          height: val(23);
        }
      }
      &.setting {
        padding: val(20) 0px;
        img {
          width: val(44);
          height: val(36);
        }
      }
    }
  }
}
#board {
  width: 100%;
  height: 100%;
  font-size: initial;
  box-shadow: 0px 3px 8px rgba(0, 0, 0, 0.5);
  ::v-deep {
    .move-dest {
      position: relative;
    }

    .move-dest::after {
      content: '';
      position: absolute;
      left: 0px;
      right: 0px;
      top: 0px;
      bottom: 0px;
      background: radial-gradient(
        rgba(20, 85, 30, 0.5) 19%,
        rgba(0, 0, 0, 0) 20%
      );
    }

    .chessboard-63f37 {
      width: 100%;
      height: 100%;
      position: relative;
      top: val(3.5);
      left: val(3.5);
    }

    .board-b72b1 {
      border: none;
      width: 100% !important;
      height: 100% !important;
      box-sizing: border-box;
    }

    .square-55d63 {
      transition: all 0.3s;
      display: flex;
      justify-content: center;
      align-items: center;
    }

    .piece-417db {
      /* width: auto !important;
      height: 100% !important; */
    }

    .numeric-fc462,
    .alpha-d2270 {
      font-size: val(24);
      color: var(--board-numeric-color);
    }
    .numeric-fc462 {
      left: val(-37);
      top: val(38);
    }
    .alpha-d2270 {
      left: val(40);
      bottom: val(-42);
    }
    .black-3c85d {
      background-color: var(--board-dark-bg-color);
    }
    .white-1e1d7 {
      background-color: var(--board-light-bg-color);
    }

    /* last move */
    .highlight-white,
    .highlight-black {
      background-color: #da7f65d9;
    }
    /* 将军 */
    .king-check {
      background: radial-gradient(
        ellipse at center,
        red 0%,
        #e70000 25%,
        rgba(169, 0, 0, 0) 89%,
        rgba(158, 0, 0, 0) 100%
      );
    }
  }
}

.board-buttons {
  position: absolute;
}
</style>
